import * as ACTION from 'actions'

const initialState = {
  faq: null,
  faqTypes: null,
  faqContents: [],
};

export function faq(state = initialState, action) {
  if (action == null) return state;

  switch (action.type) {
    case ACTION.FETCH_FAQ:
      return {
        ...state,
        faq: action.faq,
        faqTypes: action.faqTypes
      };
    case ACTION.GET_FAQ_CONTENT:
      return {
        ...state,
        faqContents: action.faqContents,
      };
    default:
      return state
  }
}
